import { render, staticRenderFns } from "./new-channel.pug?vue&type=template&id=7b957f55&lang=pug&"
import script from "./new-channel.ts?vue&type=script&lang=js&"
export * from "./new-channel.ts?vue&type=script&lang=js&"
import style0 from "./new-channel.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports